import {Company} from './proposal/company';
import {User} from './user';
import {ObjectUtil} from '../util/object-util';
import {LineOfBusiness} from './proposal/line-of-business';
import {ExpertService} from './expert-service';

export class CompanyPage extends Company {
  titlePicture: Blob = null;
  logo: Blob = null;
  description: string = null;

  offeringLOBs: LineOfBusiness[] = [];
  lookingForLOBs: LineOfBusiness[] = [];
  offeringExpertServices: ExpertService[] = [];

  users: User[] = [];

  constructor(object: any) {
    super(object);
    if (object == null) {
      return;
    }
    ObjectUtil.assign(this, object);
  }
}
